// extracted by mini-css-extract-plugin
export default {"menubutton":"MenuButton_menubutton__xl5x9"};